export const COPILOT_APP_OPEN_ACTION_FEATURE_FLAG = 'prs_copilot_app_open_action'

export function buildCopilotAppPullRequestOpenTarget({
  owner,
  repo,
  number,
}: {
  owner: string
  repo: string
  number: number
}) {
  return `ghapp://${encodeURIComponent(owner)}/${encodeURIComponent(repo)}/pull/${number}`
}
